module.exports = __webpack_public_path__ + "img/khanbank.2f48b477.png";